import { StatusBar } from "expo-status-bar";
import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
} from "react-native";
import { useRecoilState } from "recoil";
import { authActionLogin } from "../../action/actionlogin";
import { Authen, tokenState } from "../../reducer/reducer/reducer/Atom";
const { width, height } = Dimensions.get("window");
export default function App({ navigation, route }) {
  const [token, setToken] = useRecoilState(tokenState);
  // console.log(token);
  const [auth, setAuth] = useRecoilState(Authen);
  const [body, setbody] = useState({
    username: "",
    password: "",
  });
  const [error, seterror] = useState(false);

  useEffect(() => {
    if (token) {
      setAuth({
        auth: true,
      });
      navigation.navigate("Home");
    }
  }, [token]);

  async function login() {
    if (body.username.length > 0 && body.password.length > 0) {
      const Login = await authActionLogin(body);
      // console.log(Login);
      if (Login !== false) {
        seterror(false);

        setAuth({
          auth: true,
        });
        setToken(Login);
        navigation.navigate("Home");
      } else {
        seterror(true);
      }
    }
  }
  return (
    <View style={styles.container}>
      <View style={styles.backheader}>
        <Image
          source={require("../../image/Intersection 3.png")}
          style={styles.imgheader}
        />
        <Image
          source={require("../../image/logo_sosorun_update_black.png")}
          style={styles.imglogo}
        />
      </View>
      <View style={styles.backmain}>
        <View style={styles.viewinput}>
          <Image style={styles.icon} source={require("../../image/user.png")} />
          <TextInput
            onChangeText={(text) => setbody({ ...body, username: text })}
            style={styles.input}
            placeholder="Username"
          />
        </View>
        <View style={styles.viewinput}>
          <Image
            style={styles.icon}
            source={require("../../image/password.png")}
          />
          <TextInput
            secureTextEntry
            onChangeText={(text) => setbody({ ...body, password: text })}
            style={styles.input}
            placeholder="Password"
          />
        </View>
        {error && (
          <View
            onPress={() => login()}
            style={[
              styles.botton,
              { backgroundColor: "transparent", height: null },
            ]}
          >
            <Text
              style={[
                styles.text,
                { fontSize: 12, color: "red", alignSelf: "flex-start" },
              ]}
            >
              รหัสผ่านไม่ถูกต้อง
            </Text>
          </View>
        )}

        <TouchableOpacity onPress={() => login()} style={styles.botton}>
          <Text style={styles.text}>LOGIN</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.viewbar}></View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
  },
  backheader: {
    width: width,
    height: height * 0.4,
    backgroundColor: "#8898AA",
    justifyContent: "center",
  },
  imgheader: {
    width: width,
    height: height * 0.4,
    position: "absolute",
    zIndex: 99,
  },
  imglogo: {
    width: width * 0.5,
    height: 160,
    alignSelf: "center",
  },
  backmain: {
    width: width,
    height: height * 0.55,
    paddingTop: 50,
  },
  viewbar: {
    width: width,
    height: height * 0.05,
    backgroundColor: "#FCC81D",
  },
  viewinput: {
    flexDirection: "row",
    alignSelf: "center",
    marginTop: 20,
  },
  icon: {
    width: 20,
    height: 20,
    alignSelf: "center",
    marginRight: -40,
  },
  input: {
    width: width * 0.4,
    height: 50,
    borderRadius: 5,
    backgroundColor: "#fff",
    paddingHorizontal: 60,
  },
  botton: {
    width: width * 0.4,
    height: 50,
    backgroundColor: "#393939",
    borderRadius: 5,
    marginTop: 20,
    alignSelf: "center",
    justifyContent: "center",
    marginLeft: -15,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#fff",
    alignSelf: "center",
    fontWeight: "800",
  },
});
